/** arb-tools bundle name for the audit-insights messages. */
export const INSIGHTS_BUNDLE = 'features.audit-insights.translations.auditInsights';

/**
 * Keys in `auditInsights.puff.json`. Keep in lockstep with its `resources` so a typoed key
 * is a compile error rather than a string rendered raw.
 */
export type AuditInsightsMessageKey =
  | 'aiGenerated'
  | 'cardTitle'
  | 'poweredBy'
  | 'loading'
  | 'loadError'
  | 'pendingTitle'
  | 'pendingText'
  | 'failedTitle'
  | 'failedText'
  | 'incompleteOpenTitle'
  | 'incompleteNotStartedText'
  | 'incompleteInProgressText'
  | 'incompleteExpiredTitle'
  | 'incompleteCancelledTitle'
  | 'incompleteClosedText'
  | 'incompleteUnknownText'
  | 'incompletePreparingText'
  | 'pointsValue'
  | 'executiveSummaryTitle'
  | 'strengthsTitle'
  | 'strengthsPassCount'
  | 'failureThemesTitle'
  | 'questionIdChip'
  | 'taskIdChip'
  | 'recurringTitle'
  | 'recurringContext'
  | 'tileRecurring'
  | 'tileRecurringSub'
  | 'tileOpenTasks'
  | 'tileOpenTasksSub'
  | 'noPriorHistoryTitle'
  | 'noPriorHistoryText'
  | 'openTasksUnavailable'
  | 'recurringFailNotConsecutive'
  | 'recurringFailSecond'
  | 'recurringFailThird'
  | 'recurringFailPersistent'
  | 'recurringRowStreak'
  | 'recurringRowStreakCapped'
  | 'openTaskView'
  | 'detailDuePastDue'
  | 'recurringLastAnswered'
  | 'recurringLastAnsweredOnly'
  | 'openTaskCreated'
  | 'openTaskCreatedOnly'
  | 'openTaskAssignee'
  | 'openTaskDue'
  | 'panelRecurringTitle'
  | 'panelOpenTasksTitle'
  | 'panelRecurringEmpty'
  | 'panelOpenTasksEmpty'
  | 'panelRecurringHint'
  | 'panelOpenTasksHint'
  | 'detailReadOnly'
  | 'detailClose'
  | 'detailResult'
  | 'detailAnsweredOn'
  | 'detailAnsweredBy'
  | 'detailRecurrence'
  | 'detailPriorAudit'
  | 'detailStatus'
  | 'detailLinkedQuestion'
  | 'detailCreated'
  | 'detailCreatedBy'
  | 'detailAssignee'
  | 'detailDue'
  | 'detailNotRecorded'
  | 'resultPass'
  | 'resultFail'
  | 'resultNa'
  | 'breakdownTitle'
  | 'breakdownPass'
  | 'breakdownFail'
  | 'breakdownNa'
  | 'breakdownTotal'
  | 'questionsNoneMatch'
  | 'questionsPaginationLabel'
  | 'questionsTitle'
  | 'questionsContext'
  | 'columnQuestionId'
  | 'columnQuestion'
  | 'columnPoints'
  | 'columnStatus'
  | 'statusPending';
